// Keys set by MobileProtectedRoute / mobile customer flow. Must not override seller auth on desktop.

export const MOBILE_FLOW_TEMP_STORAGE_KEYS = [
  'temp_authToken',
  'temp_tokenScope',
  'temp_tokenType',
  'temp_tokenSaleId',
  'temp_tokenCustomerId',
  'temp_tokenPurchaseRequestId',
  'temp_tokenBranchId',
  'temp_tokenDni',
  'temp_handoffContext',
  'temp_tokenLastValidation',
];

export function clearMobileFlowTempStorage() {
  MOBILE_FLOW_TEMP_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
}

export function isMobileAppPath() {
  return typeof window !== 'undefined' && window.location.pathname.startsWith('/m/');
}
